export default __webpack_public_path__ + "static/media/icon-arrow-left-lightblue.9e0095dd.svg";